module.exports = __webpack_public_path__ + "img/daytime-bg-img.d8bfa32f.jpg";